export class ConfigurationDetails {
    configId: string;
	configKey: string;
	configValue: string;
	configType: string;
	systemConfig: boolean;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/configurations/details/configuration-details.model.ts